/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Grid } from '@mui/material'
import _ from 'lodash'
import React, { useState } from 'react'
import { useAsyncFetch } from 'react-hooks-async-handlers'
import { RendererStatusSplit } from 'react-renderer-status-split'
import { FadeLoader } from 'react-spinners'
import useModalState from '../../../hooks/useModalState'
import apiWalletClient from '@app/libs/api-wallet-client/api'
import { Currency } from '@app/typings/core'
import ModalChainSelect from '../modals/ModalChainSelect'
import ModalCurrencySelect from '../modals/ModalCurrencySelect'
import DepositFormChain from './DepositFormChain'
import MockedInput from './components/MockedInput'

interface Props {
  currency: Currency
  onSelect(currency: Currency): any
  onChainChange(chain_id: string | null): any
}

function DepositFormCurrency(props: Props) {
  const { currency, onSelect, onChainChange } = props
  const [chain_id, setChainId] = useState<string | null>(null)
  const { id: currency_id, name, symbol, logo } = currency

  const modalCoinSelect = useModalState(false)
  const modalChainSelect = useModalState(false)

  const fetchChains = useAsyncFetch(async () => {
    const chains = await apiWalletClient.currency.getChains({ currency_id })

    if (!chain_id) {
      const chainDefault = chains[0]
      if (chainDefault) {
        console.log('select default chain:', chainDefault)
        handleSetChain(chainDefault.id)
      }
    }

    return chains
  }, [currency_id])

  const handleSetChain = (chain_id_next: string | null) => {
    setChainId(chain_id_next)
    onChainChange(chain_id_next)
  }
  const handleCurrencySelect = (currency: Currency) => {
    handleSetChain(null)
    onSelect(currency)
  }

  const handleChainSelect = (chain) => {
    handleSetChain(chain.id)
  }

  return (
    <div>
      <ModalCurrencySelect {...modalCoinSelect} onSelect={handleCurrencySelect} title={'Select crypto to deposit'} />
      <ModalChainSelect
        {...modalChainSelect}
        onSelect={handleChainSelect}
        chains={fetchChains.data || []}
        preventDisabledState
      />

      <MockedInput name={name} short_name={symbol} onClick={modalCoinSelect.onOpen} logo={logo} />

      <RendererStatusSplit
        statuses={fetchChains}
        renderEmpty={() => null}
        renderLoading={() => (
          <Grid container justifyContent={'center'}>
            <FadeLoader />
          </Grid>
        )}
        render={(chains) => {
          // console.log('renderer', data)
          const chain = _.find(chains, (item) => item.id === chain_id)
          if (!chain) return null

          return (
            <div>
              <DepositFormChain chain={chain} onChainClick={modalChainSelect.onOpen} />
            </div>
          )
        }}
      />
    </div>
  )
}

export default DepositFormCurrency
